// extracted by mini-css-extract-plugin
export default {"loading-container":"LoadingPage_loading-container__zyFYU","loading-spinner":"LoadingPage_loading-spinner__m0mHo","spin":"LoadingPage_spin__vs9AI"};